import PropTypes from 'prop-types';
import React from 'react';
import { FormattedTime } from 'react-intl';
import RosettaFormattedMessage from '../rosetta_formatted_message';
import PublicationDate from './publication_date';

const PublicationDateTime = ({ timestamp }) => (
  <RosettaFormattedMessage parentFilename={__filename}
    id="formatted_date_time"
    description="Text of the formatted publication timestamp on article pages"
    defaultMessage="{date}, {time}"
    values={{
      date: React.createElement(PublicationDate, { timestamp }),
      time: (
        <FormattedTime value={timestamp}
          hour="numeric"
          minute="2-digit"
        />
      )
    }}
  />
);

PublicationDateTime.propTypes = {
  timestamp: PropTypes.number.isRequired
};

export default PublicationDateTime;
